import { z } from "zod";

export const DeviceHealthHistorySchema = z.object({
  id: z.number().int().optional(),
  device_id: z.string().trim().min(1),
  heartbeat_timestamp: z.string(),
});

export type DeviceHealthHistory = z.infer<typeof DeviceHealthHistorySchema>;
